import { render, staticRenderFns } from "./mstrcollectability.vue?vue&type=template&id=da9c0fc4&"
import script from "./mstrcollectability.vue?vue&type=script&lang=js&"
export * from "./mstrcollectability.vue?vue&type=script&lang=js&"
import style0 from "./mstrcollectability.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports